module.exports = __webpack_public_path__ + "img/ticket_black.2b4bfccf.svg";